import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [stage, setStage] = useState('qr'); // qr -> pos -> wallet -> merge -> moveToNav

  useEffect(() => {
    const qrTimer = setTimeout(() => setStage('pos'), 600);
    const posTimer = setTimeout(() => setStage('wallet'), 1200);
    const walletTimer = setTimeout(() => setStage('merge'), 1800);
    const mergeTimer = setTimeout(() => setStage('moveToNav'), 2200);
    const completeTimer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 2800);

    return () => {
      clearTimeout(qrTimer);
      clearTimeout(posTimer);
      clearTimeout(walletTimer);
      clearTimeout(mergeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)',
        opacity: stage === 'moveToNav' ? 0 : 1,
        transition: 'opacity 0.5s ease-out',
      }}
    >
      {/* Journey Container */}
      <div
        style={{
          position: 'relative',
          width: '600px',
          maxWidth: '90vw',
          height: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 40px',
          transform: stage === 'merge' ? 'scale(0.3)' : stage === 'moveToNav' ? 'scale(0.2) translateY(-300px)' : 'scale(1)',
          opacity: stage === 'merge' ? 0.5 : stage === 'moveToNav' ? 0 : 1,
          transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {/* QR Code Icon */}
        <div
          style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: stage === 'qr' || stage === 'pos' || stage === 'wallet' || stage === 'merge' 
              ? 'linear-gradient(135deg, #1B9E4B 0%, #159642 100%)' 
              : '#e5e7eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: stage === 'qr' || stage === 'pos' || stage === 'wallet' || stage === 'merge'
              ? '0 10px 30px rgba(27, 158, 75, 0.4)'
              : 'none',
            transform: stage === 'qr' ? 'scale(1.1)' : 'scale(1)',
            transition: 'all 0.4s ease-out',
          }}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M3 11h8V3H3v8zm2-6h4v4H5V5zm8-2v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm13 2h3v3h-3v-3zm0-2v-3h2v-2h-2v-2h-2v2h-3v2h2v3h-2v3h3v2h-3v2h5v-2h2v-2h-2v-3z"/>
          </svg>
          {stage === 'qr' && (
            <div style={{
              position: 'absolute',
              inset: '-10px',
              borderRadius: '20px',
              background: 'radial-gradient(circle, rgba(27, 158, 75, 0.4) 0%, transparent 70%)',
              animation: 'ping 1s ease-out infinite',
            }}/>
          )}
        </div>

        {/* Line QR to POS */}
        <svg
          style={{
            position: 'absolute',
            left: '120px',
            top: '50%',
            width: '140px',
            height: '4px',
            marginTop: '-2px',
          }}
          viewBox="0 0 140 4"
        >
          <line
            x1="0"
            y1="2"
            x2="140"
            y2="2"
            stroke="#1B9E4B"
            strokeWidth="4"
            strokeDasharray="140"
            strokeDashoffset={stage === 'qr' ? 140 : 0}
            style={{
              transition: 'stroke-dashoffset 0.5s ease-out',
            }}
          />
        </svg>

        {/* POS Icon */}
        <div
          style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: stage === 'pos' || stage === 'wallet' || stage === 'merge'
              ? 'linear-gradient(135deg, #1B9E4B 0%, #159642 100%)'
              : '#e5e7eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: stage === 'pos' || stage === 'wallet' || stage === 'merge'
              ? '0 10px 30px rgba(27, 158, 75, 0.4)'
              : 'none',
            transform: stage === 'pos' ? 'scale(1.1)' : 'scale(1)',
            transition: 'all 0.4s ease-out',
          }}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
          </svg>
          {stage === 'pos' && (
            <div style={{
              position: 'absolute',
              inset: '-10px',
              borderRadius: '20px',
              background: 'radial-gradient(circle, rgba(27, 158, 75, 0.4) 0%, transparent 70%)',
              animation: 'ping 1s ease-out infinite',
            }}/>
          )}
        </div>

        {/* Line POS to Wallet */}
        <svg
          style={{
            position: 'absolute',
            right: '120px',
            top: '50%',
            width: '140px',
            height: '4px',
            marginTop: '-2px',
          }}
          viewBox="0 0 140 4"
        >
          <line
            x1="0"
            y1="2"
            x2="140"
            y2="2"
            stroke="#1B9E4B"
            strokeWidth="4"
            strokeDasharray="140"
            strokeDashoffset={stage === 'pos' || stage === 'qr' ? 140 : 0}
            style={{
              transition: 'stroke-dashoffset 0.5s ease-out',
            }}
          />
        </svg>

        {/* Wallet Icon */}
        <div
          style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: stage === 'wallet' || stage === 'merge'
              ? 'linear-gradient(135deg, #1B9E4B 0%, #159642 100%)'
              : '#e5e7eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: stage === 'wallet' || stage === 'merge'
              ? '0 10px 30px rgba(27, 158, 75, 0.4)'
              : 'none',
            transform: stage === 'wallet' ? 'scale(1.1)' : 'scale(1)',
            transition: 'all 0.4s ease-out',
          }}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
          </svg>
          {stage === 'wallet' && (
            <div style={{
              position: 'absolute',
              inset: '-10px',
              borderRadius: '20px',
              background: 'radial-gradient(circle, rgba(27, 158, 75, 0.4) 0%, transparent 70%)',
              animation: 'ping 1s ease-out infinite',
            }}/>
          )}
        </div>
      </div>

      {/* Roya Logo - appears during merge */}
      {(stage === 'merge' || stage === 'moveToNav') && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: stage === 'moveToNav' 
              ? 'translate(-50%, -50%) scale(0.4) translateY(-350px) translateX(-800px)'
              : 'translate(-50%, -50%) scale(1)',
            transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
            opacity: stage === 'moveToNav' ? 0 : 1,
          }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_a49fc96e-c6d1-4538-8241-3e5dffe114fb/artifacts/6uiz1cw4_WhatsApp%20Image%201447-06-18%20at%2008.46.59.jpeg"
            alt="ROYA"
            style={{
              height: '80px',
              width: 'auto',
              filter: 'drop-shadow(0 10px 30px rgba(27, 158, 75, 0.4))',
            }}
          />
        </div>
      )}

      {/* CSS Animations */}
      <style>
        {`
          @keyframes ping {
            0% {
              transform: scale(1);
              opacity: 1;
            }
            100% {
              transform: scale(1.3);
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SplashScreen;
